module.exports = __webpack_public_path__ + "img/103.67b8ff10.svg";